import isFunction from "lodash/isFunction";
import isNil from "lodash/isNil";
import LoanFilePreview from "../../screens/LoanDrilldownScreen/tabs/LoanDrilldownFilesTab/LoanFilePreview";
import SideCardModal from "./SideCardModal";
import { useDispatch, useSelector } from "react-redux";
import { useCallback, useMemo } from "react";
import { filePreviewClear } from "../../redux/reducers/filePreviewReducer";
/**
 * Usage:
   const [file, setFile] = useState(null);
   <FilePreviewSideCardModal file={file} onClose={() => setFile(null)} />
 */
const FilePreviewSideCardModal = ({ file, loan, onClose }) => {
  const loanDrilldown = useSelector((state) => state.loanDrilldown);
  const filePreview = useSelector((state) => state?.filePreview);
  const dispatch = useDispatch();

  const fileData = useMemo(() => {
    if (file) {
      return file;
    }

    return filePreview?.data;
  }, [filePreview, file]);

  const handleClose = useCallback(() => {
    if (fileData) {
      dispatch(filePreviewClear());
    }
  }, [fileData, onClose, dispatch]);

  if (isNil(fileData)) {
    return null;
  }
  return (
    <SideCardModal
      hideHeader
      // title={file?.file_display_name || "File Preview"}
      show={!isNil(fileData)}
      onClose={handleClose}
      suppressBodyPadding
    >
      <LoanFilePreview
        loan={loan || loanDrilldown}
        fileObject={fileData}
        onClose={handleClose}
        containerId={fileData?.containerName}
      />
    </SideCardModal>
  );
};

export default FilePreviewSideCardModal;
